import * as Blockly from 'blockly/core';
// import { FieldTextInput, Field, FieldTextInputValidator, FieldTextInputConfig } from 'blockly/core';


/**
 * Class for an editable pitch field.
 * @param {string} text The initial content of the field.
 * @extends {Blockly.FieldTextInput}
 * @constructor
 */
export class VmtFieldFlyoutText extends Blockly.FieldTextInput {
  static cssClassName = 'vmtFlyoutField';
  /**
   * Milliseconds to wait before showing flydown after mouseover event on flydown
   * field.
   * @type {number}
   * @const
   */
  static timeout = 500;

  /**
   * Process ID for timer event to show flydown (scheduled by mouseover event).
   * @type {number}
   * @const
   */
  static showPid_ = 0;

  /**
   * Which instance of VmtFieldFlyoutText (or a subclass) is an open flydown attached
   * to?
   * @type {VmtFieldFlyoutText|null}
   */
  static openFieldFlyout_ = null;

  // These control the positions of the flydown.
  static DISPLAY_BELOW = 'BELOW';
  static DISPLAY_RIGHT = 'RIGHT';
  static DISPLAY_LOCATION = VmtFieldFlyoutText.DISPLAY_BELOW;

  // /**
  //  * Array holding info needed to unbind events.
  //  * Used for disposing.
  //  * @type {!Array<!Blockly.browserEvents.Data>}
  //  * @private
  //  */
  // boundEvents_ = [];
  noFlyout_ = false;
  paramName_ = '';
  paramId_ = '';
  flyoutContent_ = '';

  constructor(text, noFlyout = false) {
    super(text);
    // console.log('VmtFlyoutTextField', text);
    this.noFlyout_ = noFlyout; // If true, don't show flydown.
    // Disable spellcheck.
    this.setSpellcheck(false);

  }

  initView() {
    super.initView();
    console.log('VmtFlyoutTextField initView');
    if (!this.noFlyout_) {
      this.mouseOverWrapper_ =
        Blockly.browserEvents.bind(this.fieldGroup_, 'mouseover', this,
          this.onMouseOver_);
      this.mouseOutWrapper_ =
        Blockly.browserEvents.bind(this.fieldGroup_, 'mouseout', this,
          this.onMouseOut_);
    }
    Blockly.utils.dom.addClass(this.fieldGroup_, VmtFieldFlyoutText.cssClassName);
  }

  /**
   * Show the inline free-text editor on top of the text and the pitch picker.
   * @protected
   */
  showEditor_() {
    super.showEditor_();
  }

  /**
   * Get the text to be displayed on the field node.
   * @returns {?string} The HTML value if we're editing, otherwise null.
   * Null means the super class will handle it, likely a string cast of value.
   * @protected
   */
  getText_() {
    if (this.isBeingEdited_) {
      return super.getText_();
    }
    return this.getValue();
  }

  /**
   * Transform the provided value into a text to show in the HTML input.
   * @param {*} value The value stored in this field.
   * @returns {string} The text to show on the HTML input.
   */
  getEditorText_(value) {
    return this.getValue();
  }

  /**
   * Transform the text received from the HTML input (note) into a value
   * to store in this field.
   * @param {string} text Text received from the HTML input.
   * @returns {*} The value to store.
   */
  getValueFromEditorText_(text) {
    return text;
  }

  /**
   * Handle a mouse over event on the field.
   * @param {!Event} e Mouse over event.
   * @protected
   */
  onMouseOver_(e) {
    // console.log('onMouseOver_', e);
    if (!this.sourceBlock_.isInFlyout && VmtFieldFlyoutText.showPid_ === 0) {
      VmtFieldFlyoutText.showPid_ =
        window.setTimeout(this.showFlyoutMaker_(),
          VmtFieldFlyoutText.timeout);
    }
    e.stopPropagation();
  }

  /**
   * Handle a mouse out event on the field.
   * @param {!Event} e Mouse out event.
   * @protected
   */
  onMouseOut_(e) {
    // Clear any pending timer event to show flydown
    window.clearTimeout(VmtFieldFlyoutText.showPid_);
    VmtFieldFlyoutText.showPid_ = 0;
    e.stopPropagation();
  }

  /**
   * Returns a thunk that creates a Flydown block of the getter and setter blocks
   * for receiver field.
   * @this {VmtFieldFlyoutText}
   * @returns {function()} A function that creates a flydown block of the getter
   */
  showFlyoutMaker_() {
    // Name receiver in variable so can close over this variable in returned thunk
    const field = this;
    return function () {
      if (VmtFieldFlyoutText.showPid_ !== 0 &&
        !field.getSourceBlock().workspace.isDragging() &&
        !this.htmlInput_) {
        try {
          const fieldSourceBlock = field.getSourceBlock();
          if (fieldSourceBlock.type === 'vmt_reusable_brick_init') {
            field.showFlyout_(fieldSourceBlock);
          }
          else if (fieldSourceBlock.type === 'vmt_parameter') {
            field.showFlyout_(fieldSourceBlock.getSurroundParent());
          }
        } catch (e) {
          console.error('Failed to show flydown', e);
        }
      }
      VmtFieldFlyoutText.showPid_ = 0;
    };
  }


  setFlyoutContent(flyoutContent) {
    this.flyoutContent_ = flyoutContent;
  }

  /**
   * Show the flyout for this field.
   * @param {!Blockly.Block} parentBlock The workspace in which to show the flyout.
   * @this {VmtFieldFlyoutText}
   * @protected
   */
  showFlyout_(parentBlock) {
    console.log('showFlyout_');
    const workspace = parentBlock.workspace;
    workspace.hideChaff();
    const flyout = workspace.getVmtFlyout();

    // Add flydown to top-level svg, *not* to main workspace svg
    // This is essential for correct positioning of flydown via translation
    // (If it's in workspace svg, it will be additionally translated by
    //  workspace svg translation relative to Blockly.svg.)
    workspace.getParentSvg().appendChild(flyout.svgGroup_);

    // Adjust scale for current zoom level
    const scale = flyout.targetWorkspace.scale;
    flyout.workspace_.setScale(scale);

    const blocksXMLText = this.flyoutContent_;
    // const blocksXMLText =
    //   '<xml>' +
    //   '<block type="vmt_parameter_reference" data="rb">' +
    //   '<field name="PARAMETER_NAME">' +
    //   this.getText() +
    //   '</field>' +
    //   '<field name="PARENT_BLOCK_ID">' +
    //   parentBlock.id +
    //   '</field>' +
    //   '<field name="PARAM_ID">' +
    //   this.paramId_ +
    //   '</field>' +
    //   '</block>' +
    //   '</xml>';
    const blocksDom = Blockly.utils.xml.textToDom(blocksXMLText);
    const blocksXMLList = this.getChildren_(blocksDom);
    const x = this.borderRect_.getAttribute('x');
    console.log('x', x);

    const xy = workspace.getSvgXY(this.borderRect_);
    const borderBBox = this.borderRect_.getBBox();
    if (this.displayLocation === VmtFieldFlyoutText.DISPLAY_BELOW) {
      xy.y += borderBBox.height * scale;
    }
    else { // Display right.
      xy.x += borderBBox.width * scale;
    }

    // Set the flydown's current field.  Note that this is subtly differnt than
    // FieldFlydown.openFieldFlydown_ because the latter might get reset
    // by an iterim hiding of the field and not get set again by an interim call
    // to show().
    flyout.field_ = this;
    flyout.showAt(blocksXMLList, xy.x, xy.y);
    VmtFieldFlyoutText.openFieldFlydown_ = this;
  }

  /**
   * Ensure that only a valid value may be entered.
   * @param {*} opt_newValue The input value.
   * @returns {*} A valid value, or null if invalid.
   */
  doClassValidation_(opt_newValue) {
    if (opt_newValue === null || opt_newValue === undefined) {
      return null;
    }
    return opt_newValue;
  }


  /**
   * Returns an array containing just the element children of the given element.
   * @param {Element} element The element whose element children we want.
   * @return {!(Array<!Element>|NodeList<!Element>)} An array or array-like list
   *     of just the element children of the given element.
   * @private
   */
  getChildren_(element) {
    // We check if the children attribute is supported for child elements
    // since IE8 misuses the attribute by also including comments.
    if (element.children !== undefined) {
      return element.children;
    }
    // Fall back to manually filtering the element's child nodes.
    return Array.prototype.filter.call(element.childNodes, function (node) {
      return node.nodeType === Blockly.utils.dom.NodeType.ELEMENT_NODE;
    });
  }
}

Blockly.fieldRegistry.register('vmt_flyout_edit_field', VmtFieldFlyoutText);
